import React from 'react'
import s from './styles/Header.module.scss'
import { useStudentSearch } from 'shared/hooks/useStudentSearch'
import NotificationDropdown from 'widgets/NotificationDropdown/NotificationDropdown'
import useHeaderMobileSearch from './hooks/useHeaderMobileSearch'
import HeaderSearchBlock from './components/HeaderSearchBlock/HeaderSearchBlock'
import HeaderSearchToggle from './components/HeaderSearchToggle/HeaderSearchToggle'
import HeaderSettingsButton from './components/HeaderSettingsButton/HeaderSettingsButton'

export const Header = ({
	page = null,
	onSearchChange,
	headerActions = null,
	headerLeading = null,
	compact = false,
}) => {
	const {
		query,
		isOpen,
		isLoading,
		results,
		containerRef,
		handleChange,
		handleFocus,
		handleSelectStudent,
	} = useStudentSearch()

	const { isMobile, searchExpanded, toggleSearch, collapseSearch } =
		useHeaderMobileSearch()

	const handleSearchInputChange = e => {
		handleChange(e)
		onSearchChange?.(e)
	}

	const showMobileSearchPanel = isMobile && searchExpanded
	const showSearchClear = isMobile && searchExpanded

	return (
		<header className={`${s.header} ${compact ? s.headerCompact : ''}`}>
			<div className={s.wrap}>
				<div className={s.leadingSlot}>
					{headerLeading ? (
						<div className={s.leading}>{headerLeading}</div>
					) : (
						page && <span className={s.title}>{page}</span>
					)}
				</div>

				<div
					className={`${s.searchSlot} ${
						showMobileSearchPanel ? s.searchSlot_expanded : ''
					}`}
				>
					<HeaderSearchBlock
						containerRef={containerRef}
						query={query}
						onSearchChange={handleSearchInputChange}
						onFocus={handleFocus}
						isOpen={isOpen}
						isLoading={isLoading}
						results={results}
						onSelectStudent={handleSelectStudent}
						showClear={showSearchClear}
						onClear={collapseSearch}
					/>
				</div>

				<div className={s.actionsSlot}>
					<div className={s.actions}>
						{headerActions}
						<HeaderSearchToggle
							onClick={toggleSearch}
							isActive={searchExpanded}
						/>
						<HeaderSettingsButton />
						<NotificationDropdown compact={isMobile} />
					</div>
				</div>
			</div>
		</header>
	)
}
